import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useMediaQuery, useTheme } from '@mui/material';
import { Frame, NextPrev, Pages, Page } from '@/components/blocks/UsePagination/parts/main';

export const UsePaginationSkeleton = () => {
	const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));

	return (
		<Frame isMobile={isMobile}>
			<NextPrev disabled>
				<KeyboardArrowLeftIcon />
				{isMobile ? '' : 'Anterior'}
			</NextPrev>
			<Pages>
				{Array.from({ length: 7 }).map((_, index) => (
					<li key={index}>
						<Page disabled>{'…'}</Page>
					</li>
				))}
			</Pages>
			<NextPrev disabled>
				{isMobile ? '' : 'Siguiente'}
				<KeyboardArrowRightIcon />
			</NextPrev>
		</Frame>
	);
};
